import Badge from "../ui/Badge.jsx";

function CrownIcon() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 16 16"
      fill="currentColor"
      aria-hidden="true"
      style={{ display: "inline-block", verticalAlign: "-0.1em", marginRight: "4px" }}
    >
      <path d="M2 12h12v1.5H2V12zm1.2-7.2L4.5 7.2 8 3.5l3.5 3.7 1.3-2.4 1.5 1.1L12 12H4L2.7 5.9l.5-.1z" />
    </svg>
  );
}

function roleForUser(user) {
  if (user?.is_owner) return { key: "owner", label: "Owner", variant: "owner", showCrown: true };
  if (user?.is_admin) return { key: "admin", label: "Admin", variant: "active", showCrown: false };
  return { key: "user", label: "User", variant: "archived", showCrown: false };
}

export default function RoleBadge({ user }) {
  const { label, variant, showCrown } = roleForUser(user);
  return (
    <Badge variant={variant}>
      {showCrown ? <CrownIcon /> : null}
      {label}
    </Badge>
  );
}
